import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'calculateDateDiff',
})
export class CalculateDateDiff implements PipeTransform {
	public transform(dateStart: Date, dateNow: Date): string {
		const diffInMs = (dateNow.valueOf()) - (dateStart.valueOf());

		return this.msToHMS(diffInMs);
	}

	public pad(n): any {
		return (n < 10) ? ('0' + n) : n + '';
	}

	public msToHMS(ms): any {
		// 1- Convert to seconds:
		let seconds = ms / 1000;
		// 2- Extract hours:
		const hours = seconds / 3600; // 3,600 seconds in 1 hour
		seconds = seconds % 3600; // seconds remaining after extracting hours
		// 3- Extract minutes:
		const minutes = seconds / 60; // 60 seconds in 1 minute
		// 4- Keep only seconds not extracted to minutes:
		seconds = seconds % 60;
		// remove decimals
		const hoursString = this.pad(hours);

		return hoursString.substr(0, hoursString.indexOf('.')) + ':' + this.pad(minutes).substr(0, 2) + ':' + this.pad(seconds).substr(0, 2);
	}
}
